import Nullstack from 'nullstack';
export default function IconBoxMultiple3({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-multiple-3",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "7",
    y: "3",
    width: "14",
    height: "14",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
  }), "   ", Nullstack.element("path", {
    d: "M14 10a2 2 0 1 0 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M12 12a2 2 0 1 0 2 -2"
  }), " ");
}